import { action, computed, observable } from "mobx";
import {weChatServerLogin} from '@/services/accountRelated';
import { checkMobile, checkPassword, checkVcode } from '@/utils/checkInput';
import { mobileErrText, passwordErrText, vcodeErrText } from '@/utils/constants';
import router from '@/router';
import GlobalStore from '@/store/GlobalStore';
import log from '@/utils/log';

class SigninStore {

  /**
   * 登录后用户信息
   */
  @observable userInfo;

  @observable inputError = {
    text: '',
    type: ''
  };

  /**
   * 账号信息
   */
  @observable accountInfo = {
    openId: '',
    account: '',
    password: '',
    channel: GlobalStore.channel,
  }

  @observable toast = GlobalStore.toast

  // 登录
  @action.bound async login () {
    console.log(this);
    const {account, password} = this.accountInfo;

    if (!checkMobile(account)) {
      this.toast.text(mobileErrText)
      this.inputError = {text: mobileErrText, type: 'account'}
      return false
    }

    if (!checkPassword(password)) {
      this.toast.text(passwordErrText)
      this.inputError = {text: passwordErrText, type: 'password'}
      return false
    }

    this.inputError = {text: '', type: ''};
    const loading = this.toast.loading();

    if(sessionStorage.getItem('openId')) {
      (this.accountInfo as any).openId = sessionStorage.getItem('openId')
    }

    this.userInfo = await weChatServerLogin(this.accountInfo)
    loading.hide()
    if (this.userInfo.code !== 10000) {
      await log.logRequest({eventId: 'A007',failReason: this.userInfo.msg })
      this.toast.text(this.userInfo.code === 50003 ? this.userInfo.msg : (this.userInfo.result || this.userInfo.msg))
      return false
    }
    await log.logRequest({eventId: 'A006' })
    window.localStorage.setItem('account', this.userInfo.result.account)
    window.localStorage.setItem('userId', this.userInfo.result.uid)

    this.setCookie(this.userInfo.result.authInfoStr)
    router.push({ path: 'home' })
  }

  @action.bound inputOnChange (value: string, name: string)  {
    this.accountInfo = Object.assign({}, this.accountInfo, {[name] : value})
  }

  @action.bound routerPushSignUp () {
    router.push({ path: 'signup' })
  }

  @action.bound routerPushForgotPassword () {
    router.push({ path: 'forgotpassword'})
  }

  @action.bound setCookie (cookie) {
    document.cookie = cookie ?
      `auth_info=${cookie};path=/` :
      `auth_info=${cookie}`
  }
  
  
  @action.bound getCookie (name) {
   let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
  }
  
  @action.bound autoSignIn () {
    console.log(this.getCookie('auth_info'));
    const authInfo = this.getCookie('auth_info')
    if (authInfo && authInfo !== 'null' && !sessionStorage.getItem('openId')) {
      router.push({ path: 'home' })
    }
  }


}
export default new SigninStore();
